import { render, staticRenderFns } from "./StudentSubjects.vue?vue&type=template&id=211fdce3&scoped=true"
import script from "./StudentSubjects.vue?vue&type=script&lang=js"
export * from "./StudentSubjects.vue?vue&type=script&lang=js"
import style0 from "./StudentSubjects.vue?vue&type=style&index=0&id=211fdce3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211fdce3",
  null
  
)

export default component.exports